"use client";
import { useState } from "react";
import Img from "@/public/images/login.jpg";
import Image from "next/image";
import Link from "next/link";
import Right from "@/public/icon/arrowRight.svg";
import Eye from "@/public/icon/eye.svg";
import http from "@/libs/config/http";
import { useSession } from "@/hooks/useSession";
import { useRouter } from "next/navigation";
import Cookies from "js-cookie";
import { useSnackbar } from "notistack";
const Login = ({ t }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [phoneNumber, setPhoneNumber] = useState("+994");
  const [showPassword, setShowPassword] = useState(false);
  const router = useRouter();
  const { data: session } = useSession();

  const handleInputChange = (event) => {
    let value = event.target.value;

    if (value.startsWith("+994")) {
      setPhoneNumber(value);
    } else {
      setPhoneNumber("+994" + value.replace(/^(\+994)/, ""));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const phone = phoneNumber;
    const password = e.currentTarget.password.value;

    login(phone, password);
  };

  const login = async (phone, password) => {
    try {
      const res = await fetch("https://api.iyde.az/api/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ phone, password }),
      });

      const data = await res.json();

      if (!res.ok || data?.success === false) {
        enqueueSnackbar(data?.message || t["errors.bad_credentials"], {
          variant: "error",
        });
        return;
      }

      Cookies.remove("guest_uid");

      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: data.token }),
      });

      if (!response.ok) {
        enqueueSnackbar("Token yadda saxlanmadı", { variant: "error" });
        return;
      }
      window.location.href = "/account/profile";
      enqueueSnackbar(t["success.message"], { variant: "success" });
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="xl-6 lg-6 md-6 sm-12">
          <div className="loginLeft">
            <div className="loginTitle">
              <Link href="/auth/login" className="active">
                {t["buttons_login"]}
              </Link>
              <Link href="/auth/register">{t["title.register"]}</Link>
            </div>
            <h1>{t["welcome.title"]}</h1>
            <p>{t["content_login"]}</p>
            <form action="" onSubmit={handleSubmit}>
              <div className="inputChild">
                <input
                  type="text"
                  required
                  value={phoneNumber}
                  onChange={handleInputChange}
                  placeholder={t["forms.numbers"]}
                />
              </div>
              <div className="inputChild">
                <input
                  type={showPassword ? "text" : "password"}
                  required
                  placeholder={t["forms.password"]}
                  id="password"
                  name="password"
                />
                {showPassword ? (
                  <div
                    className="eye "
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <Eye />
                  </div>
                ) : (
                  <div
                    className="eye active"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <Eye />
                  </div>
                )}
              </div>
              <Link href="/auth/forget">{t["buttons_forgot_password"]}</Link>
              <button type="submit" className="blackButton">
                {t["buttons.login"]}
                <Right />
              </button>
            </form>
          </div>
        </div>
        <div className="xl-6 lg-6 md-6 sm-12">
          <div className="img">
            <Image src={Img} alt="login" width={300} height={300} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
